/** @domain temporal -- Cross-cutting date fields */
import { z } from 'zod';
import { createDomainField } from './types';

const define = createDomainField('temporal');

// ─── Base types (unique displayFormat) ───────────────────────────────────────

export const date = define({
  label: 'Date',
  placeholder: 'MM/DD/YYYY',
  schema: z.string(),
  adapterHint: 'date',
  controlWidth: 'medium',
  displayFormat: 'date',
});

export const dateTime = define({
  label: 'Date & Time',
  schema: z.string(),
  adapterHint: 'date',
  displayFormat: 'datetime',
});

export const dateTimeTz = define({ ...dateTime, displayFormat: 'datetime-tz' });

// ─── Named date variants ─────────────────────────────────────────────────────

export const dateOfBirth = define({ ...date, label: 'Date of Birth' });
export const hireDate = define({ ...date, label: 'Hire Date' });
export const effectiveDate = define({ ...date, label: 'Effective Date' });
export const expirationDate = define({ ...date, label: 'Expiration Date' });
export const startDate = define({ ...date, label: 'Start Date' });
export const endDate = define({ ...date, label: 'End Date' });
export const approvedDate = define({ ...date, label: 'Approved Date' });

// ─── Award lifecycle dates (migrated from award.ts) ─────────────────────────

export const grantDate = define({ ...date, label: 'Grant Date' });
export const vestingStartDate = define({ ...date, label: 'Vesting Start Date' });
export const acceptanceDate = define({ ...date, label: 'Acceptance Date' });
export const adjustmentAsOfDate = define({ ...date, label: 'As Of Date' });
export const residualDate = define({ ...date, label: 'Residual Date' });
export const amortizationDate = define({ ...date, label: 'Amortization Date' });
export const evaluationPeriodStartDate = define({ ...date, label: 'Evaluation Period Start Date' });
export const evaluationPeriodEndDate = define({ ...date, label: 'Evaluation Period End Date' });
export const evaluationTargetDate = define({ ...date, label: 'Evaluation Target Date' });
export const trackingDate = define({ ...date, label: 'Tracking Date' });
